import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Redirects legacy `/puzzle` URLs to `/` while preserving Auth0 OAuth query params.
 * Without this, `<Navigate to="/" />` drops `code` and `state` before the SDK can finish login.
 */
const PuzzleLegacyRedirect: React.FC = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const hasAuthCallback = searchParams.has("code") && searchParams.has("state");
    if (hasAuthCallback) {
        return <Navigate to={{ pathname: "/", search: location.search, hash: location.hash }} replace />;
    }
    return <Navigate to="/" replace />;
};

export default PuzzleLegacyRedirect;
